// extracted by mini-css-extract-plugin
export var logo = "_4u-2";
export var logoWrapper = "_4u-1";
export var strip = "_4u-0";